exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='register-of-benefactors'] [data-component='main-title'] {\n  margin: 0 0 40px;\n}\n[data-component='register-of-benefactors'] .content {\n  -webkit-transform-origin: top;\n          transform-origin: top;\n}\n[data-component='register-of-benefactors'] .steps-container {\n  width: 100%;\n  position: relative;\n  margin: 0 0 40px;\n  -webkit-perspective: 500px;\n          perspective: 500px;\n}\n[data-component='register-of-benefactors'] .step {\n  top: 0;\n  left: 150%;\n  position: absolute;\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/register-of-benefactors/register-of-benefactors.component.styl
// module id = ../../../../../src/app/master/register-of-benefactors/register-of-benefactors.component.styl
// module chunks = main